import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import NavBar from "../Components/NavBar";
import Loaders from "../Components/FullScreenLoader";
import { Row, Col, Card, Form, Button } from "react-bootstrap";
import Api from "../Service/Api";
import { connect } from "react-redux";
import { getProfile } from "../Redux/actions/common";
import logo from "../../static/Images/logo.png";

const Login = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [formError, setFormError] = useState("");
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const handleSubmit = (event) => {
    event.preventDefault();
    setValidated(true);
    setFormError("");

    const form = event.currentTarget;
    if (!form.checkValidity()) {
      return;
    }

    setLoading(true);

    Api.post("/auth/signin", {
      email: email.trim(),
      password,
    })
      .then((res) => {
        if (res.status !== 201) {
          setFormError("Something went wrong. Please try again.");
          setLoading(false);
          return;
        }

        localStorage.setItem("Auth", "true");
        localStorage.setItem("accesstoken", res.data.accessToken);

        return Api.get(`/users/my-profile`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${res.data.accessToken}`,
          },
        })
          .then((resp) => {
            props.getProfile(resp.data);

            if (resp.data.emailVerified !== true) {
              history.push("/user-verification");
            } else {
              history.push("/");
            }
          })
          .catch(() => {
            setFormError(
              "Signed in successfully but could not load your profile. Please refresh.",
            );
            setLoading(false);
          });
      })
      .catch(() => {
        setFormError("Invalid email or password. Please try again.");
        setLoading(false);
      });
  };

  return (
    <div className="auth-layout">
      <NavBar />
      {loading && <Loaders />}

      <section className="login-page">
        <div className="login-page__backdrop" aria-hidden="true" />

        <div className="container login-page__container">
          <Row className="justify-content-center">
            <Col xs={12} sm={11} md={10} lg={9} xl={8}>
              <Card className="login-page__card">
                <Row className="g-0">
                  <Col
                    md={5}
                    className="login-page__panel login-page__panel--brand d-none d-md-flex"
                  >
                    <div className="login-page__brand-content">
                      <h2 className="login-page__brand-title">
                        Your next adventure awaits
                      </h2>
                      <p className="login-page__brand-text">
                        Sign in to book treks, manage bookings, and explore
                        curated experiences across India.
                      </p>
                    </div>
                  </Col>

                  <Col
                    md={7}
                    className="login-page__panel login-page__panel--form"
                  >
                    <div className="login-page__form-wrap">
                      <div className="login-page__mobile-brand d-md-none">
                        <img
                          src={logo}
                          alt="BookMyTrek"
                          className="login-page__logo login-page__logo--sm"
                        />
                      </div>

                      <h1 className="login-page__title">Welcome back</h1>
                      <p className="login-page__subtitle">
                        Sign in to your BookMyTrek account
                      </p>

                      {formError && (
                        <div
                          className="login-page__alert"
                          role="alert"
                          aria-live="polite"
                        >
                          {formError}
                        </div>
                      )}

                      <Form
                        noValidate
                        validated={validated}
                        onSubmit={handleSubmit}
                        className="login-page__form"
                      >
                        <Form.Group controlId="loginEmail">
                          <Form.Label>Email address</Form.Label>
                          <Form.Control
                            required
                            type="email"
                            name="email"
                            placeholder="name@example.com"
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value);
                              setFormError("");
                            }}
                            autoComplete="email"
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter a valid email address.
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group controlId="loginPassword">
                          <Form.Label>Password</Form.Label>
                          <Form.Control
                            required
                            type="password"
                            name="password"
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => {
                              setPassword(e.target.value);
                              setFormError("");
                            }}
                            autoComplete="current-password"
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter your password.
                          </Form.Control.Feedback>
                        </Form.Group>

                        <div className="login-page__forgot">
                          <Link
                            to="/forgot-password"
                            className="login-page__link"
                          >
                            Forgot password?
                          </Link>
                        </div>

                        <Button
                          type="submit"
                          className="login-page__submit"
                          disabled={loading}
                        >
                          Sign in
                        </Button>
                      </Form>

                      <p className="login-page__signup">
                        Don&apos;t have an account?{" "}
                        <Link
                          to="/signup"
                          className="login-page__link login-page__link--bold"
                        >
                          Create one
                        </Link>
                      </p>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getProfile: (data) => dispatch(getProfile(data)),
});

export default connect(null, mapDispatchToProps)(Login);
